"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STRIPE_API_KEY = exports.ALGOLIA_DEFAULT_INDEX = exports.ALGOLIA_APPLICATION_ID = exports.ALGOLIA_API_KEY = void 0;
exports.ALGOLIA_API_KEY = '85194a1433e4196466a0f80135439c79';
exports.ALGOLIA_APPLICATION_ID = '5O7BRBEIVD';
exports.ALGOLIA_DEFAULT_INDEX = process.env.NODE_ENV === 'production' || process.env.LOCAL_SERVER
    ? 'prod_sandboxes'
    : 'dev_sandboxes';
exports.STRIPE_API_KEY = process.env.NODE_ENV === 'production'
    ? 'pk_live_KeUgofl1VrjTtbrhhN7gGI9W'
    : 'pk_test_0HgnQIkQJCECIFCQkafGQ5gA';
